export type WorkExperienceItem = {
  role: string;
  company: string;
  description: string;
  techStack?: string;
  period?: string;
  location?: string;
};

export const WORK_EXPERIENCE: WorkExperienceItem[] = [
  {
    location: 'Edinbrugh, UK (Remote)',
    period: '2018 - Present',
    role: 'Senior React Native Developer',
    company: 'GearedApp Ltd',
    description:
      'Building and scaling over 20 React Native apps with a focus on performance, reliable releases, and smooth UX across iOS and Android.',
  },
  {
    location: 'Pensylvania, US',
    role: 'Lead Developer',
    period: 'Contractor',
    company: 'Global New Media Holdings, LLC',
    techStack:
      'React Native, TypeScript, Node.js, State Management, Push Notifications, Firebase, NestJS, CI/CD',
    description:
      'Led end-to-end development of a civic technology platform enabling U.S. constituents to communicate directly with their elected representatives and members of Congress.',
  },
  {
    location: 'San Francisco, US',
    role: 'Lead Mobile Developer',
    period: 'Contractor',
    company: '77Labs Inc.',
    techStack:
      'React Native, TypeScript, Push Notifications, Web Socket Live Streaming & Chat, State Management, CI/CD',
    description:
      'Led mobile app development for WANTD, a live commerce and social marketplace platform focused on sneakers, streetwear, and collectibles. Coordinated cross-functionally between two mobile developers and backend engineers to deliver a scalable, feature-rich product.',
  },
  {
    location: 'Vienna, Austria',
    role: 'Senior React Native Developer',
    period: 'Contractor',
    company: 'ToolSense',
    techStack:
      'React Native, TypeScript, Push Notifications, GraphQL, Jest, Detox, Maestro, CI/CD',
    description:
      'Supporting the growth and scaling of ToolSense’s mobile product. Contributed both hands-on development and strategic technical consultancy during a period of significant product expansion.',
  },
  {
    location: 'Sofia, Bulgaria',
    period: 'Contractor',
    role: 'Senior React Native Developer',
    company: 'Economedia',
    techStack:
      'React Native, State Management, In-App Payments, Push Notifications, Network Operator Integration, REST APIs',
    description:
      'Responsible for the maintenance, modernization, and continuous improvement of two cross-platform mobile applications serving the newspaper’s digital audience. Played a key role in stabilizing legacy systems while incrementally evolving the apps into scalable, high-performance mobile platforms.',
  },
];
